import { ArrowRightIcon, Brand, BrandJusIa, Button, Heading } from '@farol-ds/react'
import { useGA4Dispatcher } from '@jusbrasil-web/shared-ga4'
import {
  COMPONENT_CLASS,
  COMPONENT_NAME,
  GA4ClickEvent,
  SELECTED_OPTION,
} from '@jusbrasil-web/shared-ga4-events'
import classNames from 'classnames'

import { SegmentationType } from '../../pages/blog/types'
import styles from './blog-banner.module.scss'

export interface BlogBannerProps {
  typeSegmentation: SegmentationType
  className?: string
}

interface BannerConfig {
  title: string
  ctaText: string
  ctaLink: string
  imageComponent: React.ReactNode
  variantClass: string
}

const JUS_IA_CONFIG: BannerConfig = {
  title: 'Conheça o Jus IA, a Inteligência Artificial feita para advogados',
  ctaText: 'Conhecer o Jus IA',
  ctaLink: 'https://ia.jusbrasil.com.br/',
  imageComponent: <BrandJusIa onlySymbol width={123} height={123} />,
  variantClass: styles.variantJusIa,
}

const DEFAULT_CONFIG: BannerConfig = {
  title: 'Acelere suas pesquisas jurídicas com um dos planos do Jusbrasil',
  ctaText: 'Conhecer nossos planos',
  ctaLink: 'https://www.jusbrasil.com.br/pro',
  imageComponent: <Brand onlySymbol width={123} height={123} />,
  variantClass: styles.variantPlans,
}

const SEUS_DIREITOS_CONFIG: BannerConfig = {
  title: 'Tire suas dúvidas jurídicas rapidamente',
  ctaText: 'Entender os meus direitos',
  ctaLink: 'https://www.jusbrasil.com.br/seus-direitos',
  imageComponent: <Brand onlySymbol width={123} height={123} />,
  variantClass: styles.variantDoubts,
}

const CONSULTA_PROCESSUAL_CONFIG: BannerConfig = {
  title: 'Consulte processos de outras pessoas ou empresas',
  ctaText: 'Consultar um processo',
  ctaLink: 'https://www.jusbrasil.com.br/consulta-processual',
  imageComponent: <Brand onlySymbol width={123} height={123} />,
  variantClass: styles.variantProcess,
}

const CONFIG_MAP: Record<NonNullable<SegmentationType>, BannerConfig> = {
  PESQUISA_JURIDICA: JUS_IA_CONFIG,
  CONSULTA_PROCESSUAL: CONSULTA_PROCESSUAL_CONFIG,
  SEUS_DIREITOS: SEUS_DIREITOS_CONFIG,
}

export function BlogBanner({ typeSegmentation, className }: BlogBannerProps) {
  const config = typeSegmentation ? CONFIG_MAP[typeSegmentation] : DEFAULT_CONFIG
  const { sendGA4Event } = useGA4Dispatcher()

  const handleCtaClick = () => {
    sendGA4Event(
      new GA4ClickEvent({
        componentClass: COMPONENT_CLASS.BLOG_FEED,
        componentName: COMPONENT_NAME.BLOG_BANNER,
        selectedOption: SELECTED_OPTION.BLOG_BANNER_CTA,
      })
    )
  }

  return (
    <div className={classNames(styles.container, config.variantClass, className)}>
      <div className={styles.content}>
        <Heading size="lg" className={styles.title} asChild>
          <h3>{config.title}</h3>
        </Heading>
        <Button className={styles.ctaButton} size="md" rightIcon={<ArrowRightIcon />} asChild>
          <a href={config.ctaLink} onClick={handleCtaClick}>
            {config.ctaText}
          </a>
        </Button>
      </div>
      <div className={styles.imageWrapper}>{config.imageComponent}</div>
    </div>
  )
}
